import React from 'react';
import { Header } from './Header';
export function HeroSection() {
  return <section className="relative min-h-screen bg-slate-navy flex flex-col px-6 py-8" data-id="element-23">
      <Header data-id="element-24" />
      <div className="flex-1 flex flex-col justify-center space-y-6 mt-16" data-id="element-25">
        <div className="space-y-4" data-id="element-26">
          <p className="text-roi-red text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-27">
            Know Your Real Numbers. Every Day.
          </p>

          <h1 className="text-white text-4xl md:text-5xl font-manrope font-semibold leading-tight" data-id="element-28">
            Stop Guessing Where Your Restaurant Money Is Going.
          </h1>
        </div>
      </div>

      <div className="space-y-3 pb-8" data-id="element-29">
        <button className="w-full bg-roi-red text-white font-semibold py-4 px-6 rounded-[8px] flex items-center justify-center gap-2 hover:bg-red-700 transition-colors" data-id="element-30">
          Book a Demo
        </button>

        <button className="w-full border-2 border-white text-white font-semibold py-4 px-6 rounded-[8px] hover:bg-white hover:text-slate-navy transition-colors" data-id="element-31">
          See How It Works
        </button>
      </div>
    </section>;
}